import { render, staticRenderFns } from "./ModalChooseNameContent.vue?vue&type=template&id=08014533&scoped=true"
import script from "./ModalChooseNameContent.vue?vue&type=script&lang=js"
export * from "./ModalChooseNameContent.vue?vue&type=script&lang=js"
import style0 from "./ModalChooseNameContent.vue?vue&type=style&index=0&id=08014533&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08014533",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08014533')) {
      api.createRecord('08014533', component.options)
    } else {
      api.reload('08014533', component.options)
    }
    module.hot.accept("./ModalChooseNameContent.vue?vue&type=template&id=08014533&scoped=true", function () {
      api.rerender('08014533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalChooseNameContent.vue"
export default component.exports